import apiClient from './client';
import { API_ENDPOINTS } from './endpoints';

export interface Company {
  id: string;
  name: string;
  trade_name: string;
  cnpj: string;
  logo: string | null;
  status: string;
  email: string;
  phone: string;
  address: string;
  max_users: number;
  max_devices: number;
  active_users_count: number;
  active_devices_count: number;
  created_at: string;
  registration_token: string;
  require_token_for_registration: boolean;
}

export interface CompanyFormData {
  name: string;
  trade_name?: string;
  cnpj: string;
  email: string;
  phone?: string;
  address?: string;
  max_users?: number;
  max_devices?: number;
}

export const companiesApi = {
  list: async (params?: Record<string, any>): Promise<{ results: Company[]; count: number }> => {
    const response = await apiClient.get(API_ENDPOINTS.COMPANIES.LIST, { params });
    return response.data;
  },

  get: async (id: string): Promise<Company> => {
    const response = await apiClient.get(API_ENDPOINTS.COMPANIES.DETAIL(id));
    return response.data;
  },

  create: async (data: CompanyFormData): Promise<Company> => {
    const response = await apiClient.post(API_ENDPOINTS.COMPANIES.CREATE, data);
    return response.data;
  },

  update: async (id: string, data: Partial<CompanyFormData>): Promise<Company> => {
    const response = await apiClient.patch(API_ENDPOINTS.COMPANIES.UPDATE(id), data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.COMPANIES.DELETE(id));
  },
};
